export const SET_PLAYER = 'SET_PLAYER';
export const SET_GAME = 'SET_GAME';
export const SET_DRAFT_PLAYER = 'SET_DRAFT_PLAYER';
export const SET_CASHOUTS = 'SET_CASHOUTS';
